import { useLazyGetIsExistingCompanyProposalQuery, useLazyGetProposalByProposalIdQuery } from "../../../api/gms/proposal/proposal-api";
import { getErrorMessage } from "../../../utils/get-error-message.utils";

export const useLazy = () => {

    const [ checkGroupName, { data: existingGroupNameData, isLoading: isLoadingExistingGroupName, isError: isErrorExistingGroupName, error: errorExistingGroupName }] = useLazyGetIsExistingCompanyProposalQuery();
    const [ getProposalForRenewById, { data: proposalForRenewId, isLoading: isLoadingProposalForRenewId, isError: isErrorProposalForRenewId, error: errorProposalForRenewId }] = useLazyGetProposalByProposalIdQuery();

    const errorMessageCheckGroupName = getErrorMessage(errorExistingGroupName)
    const errorMessageGetProposalForRenewById = getErrorMessage(errorProposalForRenewId)

    return {
        checkGroupName,
        existingGroupNameData,
        isLoadingExistingGroupName,
        isErrorExistingGroupName,
        errorExistingGroupName,
        errorMessageCheckGroupName,

        getProposalForRenewById,
        proposalForRenewId,
        isLoadingProposalForRenewId,
        isErrorProposalForRenewId,
        errorProposalForRenewId,
        errorMessageGetProposalForRenewById
    }
}